<template>
    <draggable v-model="droplist[valdrop]" @change="changeAction($event , valdrop)" 
    :options="{group:{ name:'items', put:ra[valdrop]}}"
    class="item-cont">
    <span v-for="element in droplist[valdrop]" :key="element+valdrop" class="item-drop" :class="retroalimClass" v-html="element">
    </span>
    </draggable>
</template>
<script>
import draggable from 'vuedraggable'
export default {
    components: {
        draggable,
    },
    props: {
        dropList: {
            type: Array,
            required: false
        },
        retroaliment:{
            type:Array,
            required: false
        },
        valDrop:{
            type:String,
            default:'0'
        },
        retroalimClass:{
            type:String,
            default:'mal'
        }
    },
    data() {
        return {
            droplist:[],
            valdrop:'0',
            rbien:false,
            rmal:false,
            retroalimClass:'',
            valuepag:[],
            ra:[],
        }
    },
    watch: {

    },
    methods: {
        changeAction(valueA , valueB){
            this.$emit('changeDrop', valueA , valueB )
            console.log('value '+valueA , valueB )
        }
    },
    mounted() {
        var self = this
        self.droplist = this.dropList
        self.valdrop = this.valDrop
        self.ra = this.retroaliment
        console.log('gggggg '+self.ra)
        },
    }
</script>

<style lang="scss" scoped>
@import '../sass/helpers/variables';
@import '../sass/globals';

.item-cont{
  border-bottom: solid #12110B 2px;
  position: relative;
  min-width: 80px;
  height: 30px;
  width: auto;
  display: inline-block;
  .item-drop{
    span{
      margin: 0;
      padding: 0;
    }
  }
}
.correcto{
  color: green!important;
}
.incorrecto{
  color:indianred!important;
}
.bien { 
    color: #398B35!important;
    span{
        color: #398B35!important;
    }
}
.mal{ 
    color: indianred!important;
    span{
        color: indianred!important;
    }
}
</style>
